export const MAIN_LANGUAGES = ["fa", "en", "de", "fr", "it", "tr"];

export const MAIN_LANGUAGES_FA = {
  fa: "فارسی",
  en: "انگلیسی",
  de: "آلمانی",
  fr: "فرانسوی",
  it: "ایتالیایی",
  tr: "ترکی",
};

export const LANGUAGES_VALID_LIST = {
  faEn: "نامشخص یا فارسی یا انگلیسی", ab: "Abkhazian", aa: "Afar", af: "Afrikaans", ak: "Akan",
  sq: "Albanian", am: "Amharic", ar: "Arabic", an: "Aragonese", hy: "Armenian", as: "Assamese",
  av: "Avaric", ae: "Avestan", ay: "Aymara", az: "Azerbaijani", bm: "Bambara", ba: "Bashkir",
  eu: "Basque", be: "Belarusian", bn: "Bengali", bh: "Bihari languages", bi: "Bislama",
  bs: "Bosnian", br: "Breton", bg: "Bulgarian", my: "Burmese", ca: "Catalan, Valencian",
  km: "Central Khmer", ch: "Chamorro", ce: "Chechen", ny: "Chichewa, Chewa, Nyanja",
  zh: "Chinese", cu: "Church Slavonic, Old Bulgarian, Old Church Slavonic", cv: "Chuvash",
  kw: "Cornish", co: "Corsican", cr: "Cree", hr: "Croatian", cs: "Czech", da: "Danish",
  dv: "Divehi, Dhivehi, Maldivian", nl: "Dutch, Flemish", dz: "Dzongkha", en: "English",
  eo: "Esperanto", et: "Estonian", ee: "Ewe", fo: "Faroese", fj: "Fijian", fi: "Finnish",
  fr: "French", ff: "Fulah", gd: "Gaelic, Scottish Gaelic", gl: "Galician", lg: "Ganda",
  ka: "Georgian", de: "German", ki: "Gikuyu, Kikuyu", el: "Greek (Modern)",
  kl: "Greenlandic, Kalaallisut", gn: "Guarani", gu: "Gujarati",
  ht: "Haitian, Haitian Creole", ha: "Hausa", he: "Hebrew", hz: "Herero", hi: "Hindi",
  ho: "Hiri Motu", hu: "Hungarian", is: "Icelandic", io: "Ido", ig: "Igbo", id: "Indonesian",
  ia: "Interlingua", ie: "Interlingue", iu: "Inuktitut", ik: "Inupiaq", ga: "Irish",
  it: "Italian", ja: "Japanese", jv: "Javanese", kn: "Kannada", kr: "Kanuri", ks: "Kashmiri",
  kk: "Kazakh", rw: "Kinyarwanda", kv: "Komi", kg: "Kongo", ko: "Korean", kj: "Kwanyama, Kuanyama",
  ku: "Kurdish", ky: "Kyrgyz", lo: "Lao", la: "Latin", lv: "Latvian",
  lb: "Letzeburgesch, Luxembourgish", li: "Limburgish, Limburgan, Limburger", ln: "Lingala",
  lt: "Lithuanian", lu: "Luba-Katanga", mk: "Macedonian", mg: "Malagasy", ms: "Malay",
  ml: "Malayalam", mt: "Maltese", gv: "Manx", mi: "Maori", mr: "Marathi", mh: "Marshallese",
  ro: "Moldovan, Moldavian, Romanian", mn: "Mongolian", na: "Nauru", nv: "Navajo, Navaho",
  nd: "Northern Ndebele", ng: "Ndonga", ne: "Nepali", se: "Northern Sami", no: "Norwegian",
  nb: "Norwegian Bokmål", nn: "Norwegian Nynorsk", ii: "Nuosu, Sichuan Yi",
  oc: "Occitan (post 1500)", oj: "Ojibwa", or: "Oriya", om: "Oromo",
  os: "Ossetian, Ossetic", pi: "Pali", pa: "Panjabi, Punjabi", ps: "Pashto, Pushto",
  fa: "Persian", pl: "Polish", pt: "Portuguese", qu: "Quechua", rm: "Romansh", rn: "Rundi",
  ru: "Russian", sm: "Samoan", sg: "Sango", sa: "Sanskrit", sc: "Sardinian", sr: "Serbian",
  sn: "Shona", sd: "Sindhi", si: "Sinhala, Sinhalese", sk: "Slovak", sl: "Slovenian",
  so: "Somali", st: "Sotho, Southern", nr: "South Ndebele", es: "Spanish, Castilian",
  su: "Sundanese", sw: "Swahili", ss: "Swati", sv: "Swedish", tl: "Tagalog", ty: "Tahitian",
  tg: "Tajik", ta: "Tamil", tt: "Tatar", te: "Telugu", th: "Thai", bo: "Tibetan",
  ti: "Tigrinya", to: "Tonga (Tonga Islands)", ts: "Tsonga", tn: "Tswana", tr: "Turkish",
  tk: "Turkmen", tw: "Twi", ug: "Uighur, Uyghur", uk: "Ukrainian", ur: "Urdu", uz: "Uzbek",
  ve: "Venda", vi: "Vietnamese", vo: "Volap_k", wa: "Walloon", cy: "Welsh",
  fy: "Western Frisian", wo: "Wolof", xh: "Xhosa", yi: "Yiddish", yo: "Yoruba",
  za: "Zhuang, Chuang", zu: "Zulu",
};

const LANGUAGE_NORMALIZE = {
  en: "en", eng: "en", english: "en",
  fa: "fa", fas: "fa", per: "fa", persian: "fa", farsi: "fa",
  de: "de", deu: "de", ger: "de", german: "de", deutsch: "de",
  fr: "fr", fre: "fr", fra: "fr", french: "fr",
  it: "it", ita: "it", italian: "it", italiano: "it",
  tr: "tr", tur: "tr", turkish: "tr", türkçe: "tr",
  ara: "ar", ar: "ar",
  spa: "es", es: "es",
  rus: "ru", ru: "ru",
  chi: "zh", zho: "zh", zh: "zh",
  jpn: "ja", ja: "ja",
  kor: "ko", ko: "ko",
  hin: "hi", hi: "hi",
  por: "pt", pt: "pt",
  pol: "pl", pl: "pl",
  nld: "nl", dut: "nl", nl: "nl",
  swe: "sv", sv: "sv",
  nor: "no", no: "no",
  dan: "da", da: "da",
  fin: "fi", fi: "fi",
  tha: "th", th: "th",
  vie: "vi", vi: "vi",
  ind: "id", id: "id",
  cze: "cs", ces: "cs", cs: "cs",
  gre: "el", ell: "el", el: "el",
  heb: "he", he: "he",
  hrv: "hr", hr: "hr",
  hun: "hu", hu: "hu",
  may: "ms", msa: "ms", ms: "ms",
  rum: "ro", ron: "ro", ro: "ro",
  uk: "uk", ukr: "uk",
};

export const LANGUAGE_COLORS = {
  fa: { bg: "#1b5e20", text: "#fff" },
  en: { bg: "#0d47a1", text: "#fff" },
  tr: { bg: "#e65100", text: "#fff" },
  de: { bg: "#b71c1c", text: "#fff" },
  fr: { bg: "#4a148c", text: "#fff" },
  it: { bg: "#006064", text: "#fff" },
};

export function getLanguageName(code) {
  if (!code) return "";
  const normalized = LANGUAGE_NORMALIZE[code.toLowerCase()] || code.toLowerCase();
  if (MAIN_LANGUAGES_FA[normalized]) return MAIN_LANGUAGES_FA[normalized];
  return LANGUAGES_VALID_LIST[normalized] || code;
}

export function getLanguageNameEnglish(code) {
  if (!code) return "";
  const normalized = LANGUAGE_NORMALIZE[code.toLowerCase()] || code.toLowerCase();
  return LANGUAGES_VALID_LIST[normalized] || code;
}

export function normalizeLanguage(code) {
  if (!code) return "";
  return LANGUAGE_NORMALIZE[code.toLowerCase()] || code.toLowerCase();
}

export function getMainLanguageOptions() {
  return MAIN_LANGUAGES.map((code) => ({
    code,
    name: MAIN_LANGUAGES_FA[code],
  }));
}

export function getAllLanguageOptions() {
  const main = getMainLanguageOptions().map((l) => ({ ...l, isMain: true }));
  const others = Object.entries(LANGUAGES_VALID_LIST)
    .filter(([code]) => !MAIN_LANGUAGES.includes(code) && code !== "faEn")
    .map(([code]) => ({ code, name: LANGUAGES_VALID_LIST[code], isMain: false }))
    .sort((a, b) => a.name.localeCompare(b.name));
  return { main, others };
}

export function getLanguageColor(code) {
  const normalized = normalizeLanguage(code);
  return LANGUAGE_COLORS[normalized] || { bg: "#616161", text: "#fff" };
}
